var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box pa-20 min-height-350 overflow-y-auto mb-30"},[_c('div',{domProps:{"innerHTML":_vm._f("nl2br")(_vm.auth_info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }